import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-driver-licenses-validity',
  templateUrl: './validity.component.html',
  styleUrls: ['./validity.component.css']
})
export class ValidityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
